if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.closeEvent = new CustomEvent("product:modal-close");
        this.openEvent = new CustomEvent("product:modal-open");
      }

      hide() {
          super.hide();

          if (this.flickity) {
            this.flickity.destroy();
            this.flickity = null;
          }

          document.dispatchEvent(this.closeEvent);
      }

show(opener) {
  super.show(opener);

  requestAnimationFrame(() => {
    this.initCarousel();

    requestAnimationFrame(() => {
      this.flickity.resize();
      this.showActiveMedia();
    });
  });
}
initCarousel() {
    const carousel = this.querySelector(".product-media-modal-content");

    if (!carousel) return;

    if (!this.flickity) {
        this.flickity = new Flickity(carousel, {
             cellSelector: ".grid-item-2",
              contain: true,
              percentPosition: true,
              setGallerySize: false,
              adaptiveHeight: false,
              pageDots: false,
              prevNextButtons: true,
              fullscreen: true
        });

       imagesLoaded(carousel, () => {
            this.flickity.reloadCells();
            this.flickity.resize();
             requestAnimationFrame(() => {
        this.flickity.select(index, false, true);
    });
        });
    }
}
showActiveMedia() {
  const mediaId = this.openedBy.getAttribute("data-media-id");

  const cells = [
    ...this.querySelectorAll(".product-media-modal-content .grid-item-2"),
  ];

  const index = cells.findIndex(
    (cell) => cell.dataset.mediaId === mediaId,
  );

  if (index >= 0 && this.flickity) {
    this.flickity.select(index, false, true);
  }

  const activeMedia = cells[index];

  if (!activeMedia) return;

  const activeMediaTemplate = activeMedia.querySelector("template");
  const activeMediaContent = activeMediaTemplate
    ? activeMediaTemplate.content
    : null;

  if (
    activeMedia.nodeName === "DEFERRED-MEDIA" &&
    activeMediaContent &&
    activeMediaContent.querySelector(".js-youtube")
  ) {
    activeMedia.loadContent();
  }
}


    },
  );
}
